import React, { useState, useEffect } from 'react';
import { Wrapper, WrapperDiv } from './styles';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useOrderContext } from '../../context/order_context';
import { useCartContext } from '../../context/cart_context';
import { Country, State, City } from 'country-state-city';
// import Addresses from '../Addresses';
import {
  Checkbox,
  Flex,
  Select,
  FormLabel,
  FormControl,
} from '@chakra-ui/react';
import axios from 'axios';
import { useUserContext } from '../../context/user_context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const countries = [Country.getCountryByCode('IN')];
const states = State.getStatesOfCountry('IN');
const cities = City.getCitiesOfCountry('IN');
function AddAddress({ address, setIsAddressActive }) {
  const [selectedAddress, setSelectedAddress] = useState(address);
  const [saveAddressChecked, setSaveAddressChecked] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { currentUser } = useUserContext();
  const {
    shipping: {
      name,
      phone_number,
      address: { line1, postal_code, city, state, country },
    },
    updateShipping,
    paymentMethod,
    updatePaymentMethod,
  } = useOrderContext();
  const history = useHistory();
  const { cart } = useCartContext();
  useEffect(() => {
    if (address) {
      setSelectedAddress(address);
      // Update input fields with selected address
      updateShipping({
        target: {
          name: 'name',
          value: address.name,
        },
      });
      updateShipping({
        target: {
          name: 'phone_number',
          value: address.phoneNumber,
        },
      });
      updateShipping({
        target: {
          name: 'line1',
          value: address.address.line1,
        },
      });
      updateShipping({
        target: {
          name: 'postal_code',
          value: address.address.postal_code,
        },
      });
      updateShipping({
        target: {
          name: 'city',
          value: address.address.city,
        },
      });
      updateShipping({
        target: {
          name: 'state',
          value: address.address.state,
        },
      });
      updateShipping({
        target: {
          name: 'country',
          value: address.address.country,
        },
      });
    }
  }, [address]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const zipRegex = new RegExp('^[1-9][0-9]{5}$');

    if (!name) {
      return toast.error('Enter your Name');
    }
    if (!phone_number || !/^\d{10}$/.test(phone_number)) {
      return toast.error('Enter your phone number');
    }
    if (!line1) {
      return toast.error('Enter your Address');
    }
    if (!postal_code) {
      return toast.error('Enter your Zip Code');
    }
    if (!zipRegex.test(postal_code)) {
      return toast.error('Enter Valid Zip Code');
    }
    if (!city) {
      return toast.error('Enter your City');
    }
    if (!state) {
      return toast.error('Enter your State');
    }
    if (!country) {
      return toast.error('Enter your Country');
    }

    try {
      const userid = currentUser?.id;
      let res=await axios.put(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/address/${userid}`,
        {
          name: name,
          phoneNumber: phone_number,
          address: {
            line1: line1,
            postal_code: postal_code,
            city: city,
            state: state,
            country: country,
          },
        }
        
      );
     if(res.data.success){
      return toast.success("Address added")
     }
     else{
      return toast.error("Address already exists")
     }
    } catch (error) {
      console.log(error);
      toast.error('Address already exists');
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <input
            type='text'
            name='name'
            className='input'
            placeholder='Full name'
            value={name}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          />
        </div>

        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <input
            type='number'
            name='phone_number'
            className='input'
            placeholder='Phone number'
            value={phone_number}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          />
        </div>

        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <input
            type='text'
            name='line1'
            className='input'
            placeholder='Address'
            value={line1}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          />
        </div>

        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <input
            type='number'
            name='postal_code'
            className='input'
            placeholder='Zip Code'
            value={postal_code}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          />
        </div>
        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <input
            type='text'
            name='city'
            className='input sort-input'
            value={city}
            onChange={updateShipping}
            placeholder='Enter City'
            style={{ backgroundColor: '#ffffff' }}
          />
        </div>

        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <select
            name='state'
            className='input sort-input'
            value={state}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          >
            <option value=''>Select State</option>
            {states.map((item, index) => {
              return (
                <option key={index} value={item.stateCode}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>

        <div className='form-control border border-[#CCCCCC] bg-white rounded-md'>
          <select
            name='country'
            className='input sort-input'
            value={country}
            onChange={updateShipping}
            style={{ backgroundColor: '#ffffff' }}
          >
            <option value=''>Select Country</option>
            {countries.map((item, index) => {
              return (
                <option key={index} value={item.countryCode}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <Checkbox onChange={(e) => setSaveAddressChecked(e.target.checked)}>
          Save Address
        </Checkbox>
        <button
          type='submit'
          className='btn shipping-btn'
          style={{ backgroundColor: '#D3A143' }}
          disabled={isBtnDisabled}
        >
          confirm
        </button>
        <button
          className='btn shipping-btn mt-2'
          style={{ backgroundColor: '#D3A143' }}
          onClick={() => {
            setIsAddressActive(false);
          }}
        >
          cancel
        </button>
      </form>
    </div>
  );
}

export default AddAddress;
